import { combineReducers } from "@reduxjs/toolkit";
import { getAssignedPTW } from "./getAssignedPTW";
import { searchPTWDocumentSlice } from "./searchPTW";
import { assignPtwDocument } from "./getAssignedPTW";

export const ePTWRootReducer = combineReducers({
    searchPTWDocument: searchPTWDocumentSlice.reducer,
    getAssignedPTW: getAssignedPTW.reducer,
    assignedPTW: assignPtwDocument.reducer
});